import React from 'react';
import styles from './style.module.scss';
import { Modal, Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
export default function DeleteConfirmation({ show, ConfimationHeading, Desc, ActionText, handleClose, DeleteHandler, data, loading }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className={classNames(styles.ModalBody, `${theme}ModalBackground`)}>
                <div className={classNames(styles.ConfimationContainer, 'pb-4')}>
                    <div className={classNames(styles.Header)}>
                        <Heading heading={ConfimationHeading ? ConfimationHeading : `Delete ${data?.heading ? data?.heading : 'Project'}`} headingStyle={classNames(styles.Heading)} />
                    </div>
                    <div className={classNames(styles.ContentContainer)}>
                        <p className={classNames(`${theme}FontColor`, styles.Content)}>{Desc ? Desc : `Are you sure that you want to delete this ${data?.heading ? data?.heading : 'Project'} ?`}</p>
                        <div className={classNames(styles.BtnContainer, 'd-flex')}>
                            <CustomButton text={'Cancel'} submitHandle={handleClose} containerStyle={classNames(styles.Cancel)} />
                            <CustomButton Disable={loading} text={loading ? <Spinner size="sm" /> : ActionText || 'Delete'} submitHandle={DeleteHandler} containerStyle={classNames(styles.Delete)} />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
